import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { HERO_IMAGES } from "../../constants/ProductConstants";

export default function Hero() {
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % HERO_IMAGES.length);
    }, 4000);

    return () => clearInterval(timer);
  }, []);

  return (
    <section style={styles.container}>
      
      {/* IMAGE */}
      {HERO_IMAGES.map((img, i) => (
        <img
          key={i}
          src={img}
          alt="Cherry On Top jewellery"
          style={{
            ...styles.image,
            opacity: i === activeIndex ? 1 : 0,
            transform: i === activeIndex ? "scale(1.05)" : "scale(1)",
          }}
        />
      ))}

      {/* SOFT OVERLAY */}
      <div style={styles.overlay} />

      {/* CONTENT */}
      <div style={styles.content}>
        <h1 style={styles.heading}>
          Main Character Energy ✨
        </h1>

        <p style={styles.subtext}>
          Anti-tarnish jewellery that shines like you✨
        </p>

        <button
          style={styles.button}
          onClick={() => navigate("/anti-tarnish-jewellery")}
        >
          Shop Now
        </button>
      </div>

      {/* DOTS */}
      <div style={styles.dots}>
        {HERO_IMAGES.map((_, i) => (
          <button
            key={i}
            onClick={() => setActiveIndex(i)}
            style={{
              ...styles.dot,
              ...(activeIndex === i ? styles.dotActive : {}),
            }}
          />
        ))}
      </div>
    </section>
  );
}

const styles = {
  container: {
    position: "relative",
    width: "100%",
    height: "min(60vh, 560px)",
    maxHeight: "600px",
    overflow: "hidden",
  },

  image: {
    position: "absolute",
    inset: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
    transition: "all 1.2s ease",
  },

  overlay: {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(to bottom, rgba(0,0,0,0.2), rgba(0,0,0,0.35))",
  },

  content: {
    position: "absolute",
    inset: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 2,
    textAlign: "center",
    padding: "0 20px",
    animation: "fadeUp 1s ease",
  },

  heading: {
    fontSize: "clamp(30px, 6vw, 46px)",
    marginBottom: "12px",
    color: "#fff",
    fontWeight: "700",
    letterSpacing: "-0.5px",
  },

  subtext: {
    fontSize: "clamp(15px, 2.5vw, 18px)",
    marginBottom: "22px",
    color: "rgba(255,255,255,0.9)",
  },

  button: {
    padding: "14px 32px",
    background: "#7D1201",
    color: "#fff",
    border: "none",
    borderRadius: "999px",
    fontWeight: "600",
    fontSize: "15px",
    cursor: "pointer",
    transition: "all 0.3s ease",
    boxShadow: "0 6px 18px rgba(0,0,0,0.25)",
  },

  dots: {
    position: "absolute",
    left: "50%",
    bottom: 16,
    transform: "translateX(-50%)",
    display: "flex",
    gap: 8,
    zIndex: 3,
  },

  dot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    border: "none",
    background: "rgba(255,255,255,0.5)",
    cursor: "pointer",
  },

  dotActive: {
    background: "#fff",
    transform: "scale(1.2)",
  },
};